import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextareaDrag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextareaDrag"><Path d="M22.207 7.20703L7.20703 22.207L5.79297 20.793L20.793 5.79297L22.207 7.20703ZM22.207 15.207L15.207 22.207L13.793 20.793L20.793 13.793L22.207 15.207Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextareaDrag;
